import {BaseWrapper} from '../../framework/parameters/BaseWrapper';
import {BusinessUnit} from '../message/BusinessUnit';
import {BusinessUnitCriteria} from './BusinessUnitCriteria';
import {BusinessUnitScenario} from './BusinessUnitScenario';

export class BusinessUnitWrapper extends BaseWrapper<BusinessUnit, BusinessUnitCriteria, BusinessUnitScenario>  {}

